import { ReactNode } from "react";
import { VariantProps, tv } from "tailwind-variants";

const styles = tv({
  slots: { base: "!text-mobile-h2 md:!text-h2" },
  variants: {
    color: {
      white: "text-white",
      primary: "text-primary",
      secondary: "text-secondary",
    },
  },
  defaultVariants: {
    color: "secondary",
  },
});

interface IProps {
  children: ReactNode;
  color?: VariantProps<typeof styles>["color"];
  className?: string;
  testId?: string;
}

const H2 = ({ children, className, color, testId }: IProps) => {
  const { base } = styles({ color, className });

  return (
    <h2 data-testid={testId} className={base({ className })}>
      {children}
    </h2>
  );
};

export default H2;
